import { MINTTOKEN } from '../constants/bakery'
import { NFTTYPE } from '../constants/bakery/nft'
import { Contract } from 'web3-eth-contract'

import {
  getMasterChefContract,
  getSHIELDMasterContract,
  getWSOTEMasterContract,
  getTenMasterContract,
  getPetMasterContract,
  getPetMaster2Contract,
  getWeaponMasterContract,
  getBestMasterContract,
  getBRYMasterContract,
  getDEFI100MasterContract,
  getDEFI100OLDMasterContract,
  getBananaMasterContract,
  getPCWSMasterContract,
  getWarMasterContract,
  getWar2MasterContract,
  getDieselMasterContract,
  getMxMasterContract,
  getAliceMasterContract,
  getDfyMasterContract,
  getGfxMasterContract,
  getXDittoMasterContract,
  getSactMasterContract,
  getPet3MasterContract,
  getHyfiMasterContract,
  getGinuMasterContract,
  getLevMasterContract,
  getBondlyMasterContract,
  getTctMasterContract,
  getTkoMasterContract,
  getTkoCommonStakeERC721EarnERC20Contract,
  getStakeBmoncEarnBmonContract,
  getTkoMaster2Contract,
  getEarnBnrgMasterContract,
  getTsaMasterContract,
  getTlmMasterContract,
  getSoccerPokerGameBoxMasterContract,
  getDoggyTlmMasterContract,
  getBarkTlmMasterContract,
  getTokauTlmMasterContract,
  getDoggyBondlyMasterContract,
  getGatTlmMasterContract,
  getMasterChef2Contract,
  getWsgMasterContract,
  getDogoMasterContract,
  getBethMasterContract,
  getTokauMasterContract,
  getEggMasterContract,
  getBakeMuskMixerCommonStakeERC721EarnBake2Contract,
  getPetNFTCommonMasterContract,
  getHelmetNftCommonMasterContract,
  getSeascapeCommonNftMasterContract,
  getTokocryptoCommonNftMasterContract,
  getEth2MasterContract,
  getAethMasterContract,
  getTenPetNftMasterContract,
  getDittoCommonNftMasterContract,
  getToysCommonNftMasterContract,
  getAliceCommonNftMasterContract,
  getBondlyCommonNftMasterContract,
  getOneInchBakeCommonNftMasterContract,
  getKalataMasterContract,
  getDonMasterContract,
  getNtMasterContract,
  getMoniMasterContract,
  getKxaMasterContract,
  getEarnNblMasterContract
} from '../sushi/utils'

import {
  getSimpleStakeToysEarnGatContract,
} from '../sushi/simpleStakeERC721EarnERC20'


export function poolMasterContract(sushi: any, type?: string) {
  let contract: Contract = getMasterChefContract(sushi)
  switch (type) {
    case MINTTOKEN.PET:
      contract = getPetMasterContract(sushi)
      break
    case MINTTOKEN.BPET:
      contract = getPetMaster2Contract(sushi)
      break
    case MINTTOKEN.WEAPON:
      contract = getWeaponMasterContract(sushi)
      break
    case MINTTOKEN.BEST:
      contract = getBestMasterContract(sushi)
      break
    case MINTTOKEN.WSOTE:
      contract = getWSOTEMasterContract(sushi)
      break
    case MINTTOKEN.SHIELD:
      contract = getSHIELDMasterContract(sushi)
      break
    case MINTTOKEN.PETNFT:
      contract = getPetNFTCommonMasterContract(sushi)
      break
    case MINTTOKEN.HELMETNFT:
      contract = getHelmetNftCommonMasterContract(sushi)
      break
    case MINTTOKEN.SEASCAPENFT:
      contract = getSeascapeCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.TKONFT:
      contract = getTokocryptoCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.HATNFT:
      contract = getHelmetNftCommonMasterContract(sushi)
      break
    case MINTTOKEN.ETH2MASTER:
      contract = getEth2MasterContract(sushi)
      break
    case MINTTOKEN.AETHMASTER:
      contract = getAethMasterContract(sushi)
      break
    case MINTTOKEN.TENNFT:
      contract = getTenPetNftMasterContract(sushi)
      break
    case MINTTOKEN.TEN:
      contract = getTenMasterContract(sushi)
      break
    case MINTTOKEN.BRY:
      contract = getBRYMasterContract(sushi)
      break
    case MINTTOKEN.DEFI100:
      contract = getDEFI100MasterContract(sushi)
      break
    case MINTTOKEN.DEFI100OLD:
      contract = getDEFI100OLDMasterContract(sushi)
      break
    case MINTTOKEN.BANANA:
      contract = getBananaMasterContract(sushi)
      break
    case MINTTOKEN.PCWS:
      contract = getPCWSMasterContract(sushi)
      break
    case MINTTOKEN.WAR:
      contract = getWarMasterContract(sushi)
      break
    case MINTTOKEN.WAR2:
      contract = getWar2MasterContract(sushi)
      break
    case MINTTOKEN.DIESEL:
      contract = getDieselMasterContract(sushi)
      break
    case MINTTOKEN.MX:
      contract = getMxMasterContract(sushi)
      break
    case MINTTOKEN.ALICE:
      contract = getAliceMasterContract(sushi)
      break
    case MINTTOKEN.ALICENFT:
      contract = getAliceCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.BONDLYNFT:
      contract = getBondlyCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.DFY:
      contract = getDfyMasterContract(sushi)
      break
    case MINTTOKEN.GFX:
      contract = getGfxMasterContract(sushi)
      break
    case MINTTOKEN.XDITTO:
      contract = getXDittoMasterContract(sushi)
      break
    case MINTTOKEN.SACT:
      contract = getSactMasterContract(sushi)
      break
    case MINTTOKEN.PET3:
      contract = getPet3MasterContract(sushi)
      break
    case MINTTOKEN.HYFI:
      contract = getHyfiMasterContract(sushi)
      break
    case MINTTOKEN.GINU:
      contract = getGinuMasterContract(sushi)
      break
    case MINTTOKEN.LEV:
      contract = getLevMasterContract(sushi)
      break
    case MINTTOKEN.BONDLY:
      contract = getBondlyMasterContract(sushi)
      break
    case MINTTOKEN.TCT:
      contract = getTctMasterContract(sushi)
      break
    case MINTTOKEN.TKO:
      contract = getTkoMasterContract(sushi)
      break
    case MINTTOKEN.TKONFTSTAKE:
      contract = getTkoCommonStakeERC721EarnERC20Contract(sushi)
      break
    case MINTTOKEN.BMONCNFTSTAKE:
      contract = getStakeBmoncEarnBmonContract(sushi)
      break
    case MINTTOKEN.BMMNFTSTAKE:
      contract = getBakeMuskMixerCommonStakeERC721EarnBake2Contract(sushi)
      break
    case MINTTOKEN.TOYNFTSTAKE:
      contract = getSimpleStakeToysEarnGatContract(sushi)
      break
    case MINTTOKEN.ONEINCHBAKENFT:
      contract = getOneInchBakeCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.TKO2:
      contract = getTkoMaster2Contract(sushi)
      break
    case MINTTOKEN.BNRG:
      contract = getEarnBnrgMasterContract(sushi)
      break
    case MINTTOKEN.TSA:
      contract = getTsaMasterContract(sushi)
      break
    case MINTTOKEN.TLM:
      contract = getTlmMasterContract(sushi)
      break
    case MINTTOKEN.XDITTONFT:
      contract = getDittoCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.TLM2:
      contract = getDoggyTlmMasterContract(sushi)
      break
    case MINTTOKEN.TLM3:
      contract = getBarkTlmMasterContract(sushi)
      break
    case MINTTOKEN.TLM4:
      contract = getTokauTlmMasterContract(sushi)
      break
    case MINTTOKEN.BONDLY2:
      contract = getDoggyBondlyMasterContract(sushi)
      break
    case NFTTYPE.GAMEBOX:
      contract = getSoccerPokerGameBoxMasterContract(sushi)
      break
    case MINTTOKEN.TLM5:
      contract = getGatTlmMasterContract(sushi)
      break
    case MINTTOKEN.WSG:
      contract = getWsgMasterContract(sushi)
      break
    case MINTTOKEN.DOGO:
      contract = getDogoMasterContract(sushi)
      break
    case MINTTOKEN.TOYNFT:
      contract = getToysCommonNftMasterContract(sushi)
      break
    case MINTTOKEN.BETHMASTER:
      contract = getBethMasterContract(sushi)
      break
    case MINTTOKEN.TOKAU:
      contract = getTokauMasterContract(sushi)
      break
    case MINTTOKEN.BAKEV2:
      contract = getMasterChef2Contract(sushi)
      break
    case MINTTOKEN.EGG:
      contract = getEggMasterContract(sushi)
      break
    case MINTTOKEN.KALATA:
      contract = getKalataMasterContract(sushi)
      break
    case MINTTOKEN.DON:
      contract = getDonMasterContract(sushi)
      break
    case MINTTOKEN.NT:
      contract = getNtMasterContract(sushi)
      break
    case MINTTOKEN.MONI:
      contract = getMoniMasterContract(sushi)
      break
    case MINTTOKEN.KXA:
      contract = getKxaMasterContract(sushi)
      break
    case MINTTOKEN.NBL:
      contract = getEarnNblMasterContract(sushi)
      break
    default:
      contract = getMasterChefContract(sushi)
  }
  return contract
}